"use strict";

function EEP() {
	this.listeners = [];
}

EEP.prototype.addListener = function(emitter, event, handler) {
	
	emitter.addListener(event, handler);
	
	this.listeners.push({
		emitter:	emitter,
		event:		event,
		handler:	handler
	});
};

EEP.prototype.removeListener = function(emitter, event, handler) {
	
	for (var i in this.listeners) {
		if (
			this.listeners[i].emitter === emitter &&
			this.listeners[i].event == event &&
			this.listeners[i].handler == handler
		) {
			emitter.removeListener(event, handler);
		}
	}
};

EEP.prototype.on = function(emitter, event, handler) {
	this.addListener(emitter, event, handler);
};

EEP.prototype.once = function(emitter, event, handler) {
	
	emitter.once(event, handler);
	
	this.listeners.push({
		emitter:	emitter,
		event:		event,
		handler:	handler
	});
	
	// nem töröljük a listenert, ha az esemény eltüzelt
};

EEP.prototype.close = function() {
	
	for (var i in this.listeners) {
		this.removeListener(
			this.listeners[i].emitter,
			this.listeners[i].event,
			this.listeners[i].handler
		);
	}
	
	this.listeners = [];
};

module.exports = EEP;


// WEBPACK FOOTER //
// ./~/vfu/EEP.js